import styled from '@emotion/styled';
import { Button, Spacing, StyledDiv, Typography } from '../../../../index';
import { FC } from 'react';
import { BreakpointSizes, mq } from '@taleemabad/dsm/themes';

export interface LpRecordingStickyFooterProps {
  elapsedLabel: string;
  isPaused: boolean;
  isFinished?: boolean;
  onRestart: () => void;
  onPause: () => void;
  onResume: () => void;
  onSubmit?: () => void;
  position?: 'top' | 'bottom';
}

export const LpRecordingStickyFooter: FC<LpRecordingStickyFooterProps> = ({
  elapsedLabel,
  isPaused,
  isFinished = false,
  onRestart,
  onPause,
  onResume,
  onSubmit,
  position = 'bottom',
}) => {
  return (
    <StyledStickyContainer position={position}>
      <StyledDiv
        alignItem="center"
        justifyContent="space-between"
        width="100%"
        gap={8}
      >
        <StyledDiv flexDirection="column">
          <Typography variant="textTitleSmall">
            {isFinished ? 'Completed' : 'Recording'}
          </Typography>
          <StyledTimerText variant="textTitleLargeOnSurface">
            {elapsedLabel}
          </StyledTimerText>
        </StyledDiv>

        <StyledDiv alignItem="center" gap={8}>
          <Button
            variant="text"
            icon="history"
            onClick={onRestart}
            iconColor="--md-sys-color-primary"
          >
            Re-start
          </Button>
          {!isFinished && (
            <StyledResumeButton
              variant="filled"
              icon={isPaused ? 'play_arrow' : 'pause'}
              onClick={isPaused ? onResume : onPause}
            >
              {isPaused ? 'Resume' : 'Pause'}
            </StyledResumeButton>
          )}
        </StyledDiv>
      </StyledDiv>
    </StyledStickyContainer>
  );
};

const StyledTimerText = styled(Typography)`
  font-weight: 700;
`;

const StyledResumeButton = styled(Button)`
  min-width: 100px;
`;

const StyledStickyContainer = styled.div<{ position: 'top' | 'bottom' }>`
  position: ${({ position }) => (position === 'top' ? 'sticky' : 'fixed')};
  ${({ position }) => (position === 'top' ? 'top: 0;' : 'bottom: 0;')};
  left: 0;
  right: 0;
  background-color: var(--md-sys-color-surface);
  padding: var(--rk-spacing-lg) var(--rk-spacing-xl);
  box-shadow: ${({ position }) =>
    position === 'top'
      ? '0 4px 12px rgba(0, 0, 0, 0.08)'
      : '0 -4px 12px rgba(0, 0, 0, 0.08)'};
  z-index: 2000;
  border-${({ position }) => (position === 'top' ? 'bottom' : 'top')}: 1px solid
    var(--md-sys-color-outline-variant);

  ${mq(BreakpointSizes.desktop)} {
    /* left: 272px;  Offset for sidebar */
    padding: var(--rk-spacing-xl);
  }
`;
